// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4298":"457dbec4","5538":"9ef587b4","5942":"457dbec4","6749":"5c745074"}[chunkId] + ".chunk.css";
};